






















import { Component, Vue } from 'vue-property-decorator'
import { queryNoticeById } from '@/api/notice'

@Component({
  name: 'NoticeDetail'
})
export default class NoticeDetail extends Vue {
  private noticeInfo = {
    title: '',
    publisher: '',
    publishTime: '',
    viewCount: 0,
    content: '',
    image: ''
  }

  created() {
    this.init()
  }

  private async init() {
    const id = this.$route.query.id
    if (id) {
      // 获取公告详情
      queryNoticeById(id).then((res: any) => {
        if (res.data.code === 1) {
          this.noticeInfo = res.data.data
        } else {
          this.$message.error(res.data.msg || '获取公告信息失败')
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
    }
  }

  private goBack() {
    this.$router.push({ path: '/notice' })
  }
}
